module.exports = __webpack_public_path__ + "img/buyHuawei.29f2ba15.png";